export const formatDate = (dateString) => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('es-ES', options);
};

export const formatPrice = (price, currency = 'USD') => {
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(parseFloat(price) || 0);
};

export const reservationStatuses = {
  confirmed: { label: 'Confirmada', color: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' },
  paid: { label: 'Pagada - Por confirmar', color: 'bg-amber-500/20 text-amber-400 border-amber-500/30' },
  rejected: { label: 'Rechazada', color: 'bg-red-500/20 text-red-400 border-red-500/30' },
  expired: { label: 'Expirada', color: 'bg-red-500/15 text-red-400/70 border-red-500/20' },
  cancelled: { label: 'Cancelada', color: 'bg-zinc-500/15 text-zinc-400/70 border-zinc-500/20' },
  pending: { label: 'Pendiente de pago', color: 'bg-blue-500/20 text-blue-400 border-blue-500/30' }
};

export const eventStatuses = {
  draft: { label: 'Borrador', color: 'bg-zinc-500/20 text-zinc-300 border-zinc-500/30' },
  open: { label: 'Activo', color: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' },
  sold_out: { label: 'Agotado', color: 'bg-muted text-muted-foreground' },
};

// Prepend backend URL to a relative media path. If already absolute, return as-is.
export const mediaUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
};
